// Action constants
import {SET} from './constants';

const DEFAULT_STATE = {
  page: null,
  unsavedChanges: false,
};

const reducer = (state = DEFAULT_STATE, {type, data}) => {
  switch (type) {
    case SET: {
      return {
        ...state,
        ...data,
      };
    }

    default: {
      return state;
    }
  }
};

export default reducer;
